import AnalyticsWebClient from '@atlassiansox/analytics-web-client/client';

import { fg } from '@atlaskit/platform-feature-flags/fg';

export const isSSR: () => boolean = () => {
	const isMissingNecessaryBrowserUtils =
		typeof document === 'undefined' ||
		typeof window === 'undefined' ||
		!Document ||
		!Document.prototype ||
		!Object ||
		!Object.defineProperty;

	const isMissingBooleanFF = !fg;
	const isMissingAnalyticsWebClient = !Boolean(AnalyticsWebClient);

	if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) {
		return true;
	} else {
		return false;
	}
};
